import {
    ASSESSMENT_FETCHING,
    ASSESSMENT_FAILED,
    ASSESSMENT_SUCCESS,
    LOGOUT,
} from "../../Constants.ts";

export interface AssessmentState {
    isFetching: boolean;
    isError: boolean;
    result: any;
}

const initialState: AssessmentState = {
    isFetching: false,
    isError: false,
    result: null,
};

export default (state = initialState, { type, payload }: any): AssessmentState => {
    switch (type) {
        case ASSESSMENT_FETCHING:
            return { ...state, isFetching: true, isError: false, result: null };
        case ASSESSMENT_SUCCESS:
            return { ...state, isFetching: false, isError: false, result: payload };
        case ASSESSMENT_FAILED:
            return { ...state, isFetching: false, isError: true, result: null };
        default:
            return state;
    }
};
